import { Decimal } from './money';

/**
 * One binary event's pair payouts as a short sum, so a row paying 220 can say how
 * it got there: `['100', '100', '20']` reads `2 × 100.00 + 20.00`. Equal amounts
 * next to each other collapse into a count, keeping the order given.
 */
export function formatPairPayouts(payouts: readonly string[]): string {
  const groups: Array<{ amount: Decimal; count: number }> = [];
  for (const payout of payouts) {
    const last = groups[groups.length - 1];
    if (last?.amount.eq(payout)) last.count += 1;
    else groups.push({ amount: new Decimal(payout), count: 1 });
  }
  return groups
    .map((g) => (g.count > 1 ? `${g.count} × ${g.amount.toFixed(2)}` : g.amount.toFixed(2)))
    .join(' + ');
}
